module.exports = __webpack_public_path__ + "static/media/background.471a863b.jpg";